import { EKitchenStove } from '../../../../../packages/JsonQuery';

export const KITCHEN_STOVE_MAP_VALUE_TO_LABEL = {
  [EKitchenStove.Electric]: 'Электрическая плита',
  [EKitchenStove.Gas]: 'Газовая плита',
};
